import React from 'react';

/** Re-usable inline input used all over the dashboard */
const EditableInput = ({
  value,
  onChange,
  type = 'number',
  className = '',
  ...props
}) => (
  <input
    type={type}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className={`px-2 py-1 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
    {...props}
  />
);

export default EditableInput;
